module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art.cccb7c71.png";